<template>
  <section>
    <v-tabs dark slider-color="red">
      <v-tab
        v-for="tab in tabs"
        :key="`tab-${tab.route}`"
        ripple
        :to="{ name: tab.route }"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-card class="px-4 py-4">
      <router-view />
    </v-card>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'RegistrationSettings',
    data () {
      return {
        tabs: [
          {
            name: 'Form Constructor Attendee Registration',
            route: 'form-constructor-attendee-registration'
          },
          {
            name: 'Password settings',
            route: 'password-settings'
          },
          {
            name: 'VatId settings',
            route: 'vatid-settings'
          },
          {
            name: 'Error messages',
            route: 'error-messages'
          },
          {
            name: 'Form messages',
            route: 'form-messages'
          },
          {
            name: 'Status Settings',
            route: 'status-settings'
          },
          {
            name: 'Attendee Registration Remind',
            route: 'attendee-registration-remind'
          },
          {
            name: 'Block attendee settings',
            route: 'block-attendee-settings'
          },
          {
            name: 'Blocked IPs',
            route: 'blocked-ips'
          },
          {
            name: 'registration placeholder settings',
            route: 'registration-placeholder-settings'
          }
        ]
      }
    },
    methods: {
      ...mapActions(['getFormByType'])
    },
    created () {
      this.getFormByType('attendee_registration')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/index.vue